import React, { useEffect, useState } from 'react';
import { UserLocale } from '@teetsh/app/src/types/user';
import { useField } from 'react-final-form';
import { useSendUpdateParamsToIframe } from 'components/Iframe/useSendUpdateParamsToIframe';
import { buildEDTPDFParams } from './buildEDTPDFParams';
import { IframePreviewPDF } from 'components/Print/IframePreviewPDF';

interface Props {
  schoolyearId: string;
  schoolId: string;
  edtId: string;
  lng: UserLocale;
  classroomsWithIdsJoined: string;
  daysToDisplay: number[];
  edtTitle: string;
}

export function Body(props: Props) {
  const {
    schoolyearId,
    schoolId,
    edtId,
    lng,
    classroomsWithIdsJoined,
    daysToDisplay,
    edtTitle,
  } = props;
  const fields = useField('fonts.edt');

  const url = new URL(
    `/print/annee-scolaire/${schoolyearId}/ecole/${schoolId}/emploi-du-temps/${edtId}`,
    window.location.origin,
  );

  const [urlAsString] = useState(url.toString());
  const { iframeRef } = useSendUpdateParamsToIframe({
    url,
    search: buildEDTPDFParams({
      lng,
      settings: fields.input.value,
      classrooms: classroomsWithIdsJoined,
      // Only pass selectedDays if there are actually selected days
      selectedDays: daysToDisplay.length > 0 ? daysToDisplay : undefined,
      title: edtTitle,
    }),
  });

  useEffect(() => {
    const url2 = new URL(
      `/print/annee-scolaire/${schoolyearId}/ecole/${schoolId}/emploi-du-temps/${edtId}`,
      window.location.origin,
    );
    url2.search = buildEDTPDFParams({
      lng,
      settings: fields.input.value,
      classrooms: classroomsWithIdsJoined,
      // Only pass selectedDays if there are actually selected days
      selectedDays: daysToDisplay.length > 0 ? daysToDisplay : undefined,
      title: edtTitle,
    }).toString();
    iframeRef.current?.contentWindow?.location.replace(url2.toString());
  }, [
    fields.input.value.smallBreak,
    classroomsWithIdsJoined,
    fields.input.value.disableRelativeSlices,
    fields.input.value.splitMorningAfternoon,
  ]);

  return (
    <IframePreviewPDF
      onePage={!fields.input.value.splitMorningAfternoon}
      iframeUrl={urlAsString}
      iframeRef={iframeRef}
      landscape
    />
  );
}
